{#if !href || href === ''}
  <button class={classNames} id={ids} {...attributes} {...normalisedDataAttributes}>
    <slot />
  </button>
{:else}
  <a class:mh-compact={compact} href={href || undefined} class={classNames} id={ids} {...attributes} {...normalisedDataAttributes}>
    <slot />
  </a>
{/if}



<style lang="less">
  @import (reference) '../../../less/variables';
  @import (reference) '../../../less/mixins';

  a, button {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    white-space: nowrap;

    .footer-text-small();
    text-decoration: none;
    padding: 1em 0 !important;

    &.mh-compact {
      padding: 0;
    }

    &:hover,
    &:focus {
      color: currentColor !important;
    }
  }

  button {
    background: none !important;
    border: none !important;
    font-family: @masthead-font-family-default;

    &:hover {
      color: inherit !important;
      cursor: pointer;
    }
  }

  button:hover {
    background: none !important;
  }

</style>

<script>
  import { normaliseDataAttributes } from '../../../lib/normaliseDataAttributes';

  export let href;
  export let additionalClassNames = [];
  export let additionalIds = [];
  export let compact = false;
  export let external = false;
  export let dataAttributes = {};
  export let colorClassNames;

  $: attributes = external
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};

  $: normalisedDataAttributes = normaliseDataAttributes(dataAttributes);

  $: classNames = [colorClassNames.secondary, ...additionalClassNames].join(' ').trim();

  $: ids = [...additionalIds].join(' ').trim();
</script>
